export default __webpack_public_path__ + "assets/icons/computer.cebe9c6f.svg";